import { render } from "./basePopup.vue?vue&type=template&id=5f39f1a7&scoped=true"
import script from "./basePopup.vue?vue&type=script&lang=js"
export * from "./basePopup.vue?vue&type=script&lang=js"

import "./basePopup.vue?vue&type=style&index=0&id=5f39f1a7&lang=scss&scoped=true"

import exportComponent from "/var/www/vhosts/emblematic.es/tour.emblematic.es/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f39f1a7"]])

export default __exports__